import { ConfigureReturnStepBody } from './configure-return-step-body';
import { ConfigureReturnStepFooter } from './configure-return-step-footer';

import { messages } from './messages';

export const ConfigureReturnStep = {
  id: 'configure-return',
  title: messages.configureReturnStepText,
  body: <ConfigureReturnStepBody />,
  footer: <ConfigureReturnStepFooter />,
};
